import { trpc } from '@client/utils/trpc';
import { Alert, Card, CardContent, CardProps, Skeleton, Typography, useTheme } from '@mui/material';
import { PieChart } from '@mui/x-charts';

export type VirtualMachineChartCardProps = CardProps & {
  chain: string | null;
  showOffline?: boolean;
};

export const VirtualMachineChartCard = ({ chain, showOffline, ...rest }: VirtualMachineChartCardProps) => {
  const theme = useTheme();
  const { data, status, error } = trpc.chart.virtualMachine.useQuery({
    chain,
    showOffline,
  });

  return (
    <Card {...rest}>
      <CardContent>
        <Typography variant={'h5'}>{'Virtual Machines'}</Typography>

        {status === 'success' ? (
          <PieChart
            height={256}
            series={[
              {
                data: data.map((item) => ({
                  label: item.isVirtualMachine ? 'Yes' : 'No',
                  value: item.count,
                  color: item.isVirtualMachine ? theme.palette.success.main : theme.palette.error.main,
                })),
              },
            ]}
          />
        ) : status === 'error' ? (
          <Alert severity={'error'}>{error.message}</Alert>
        ) : (
          <Skeleton variant={'rounded'} height={256} />
        )}
      </CardContent>
    </Card>
  );
};
